import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeoComplyPopupAction } from '../actions';

export const useRunBrowserGeolocation = ({ useTransparentPopup }) => {
    const dispatch = useDispatch();

    return useCallback(async () => {
        try {
            return await new Promise((resolve, reject) => {
                if (!navigator.geolocation) {
                    resolve();
                    return;
                }

                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    timeout: 10000
                });
            });
        } catch (error) {
            publicEventsAPIService.trigger('geofencing-error', { error });

            if (error?.code === window.GeolocationPositionError?.PERMISSION_DENIED) {
                dispatch(showGeoComplyPopupAction({
                    title: 'playtech.mobile.system.geocomply.popups.geolocationNotAvailable.title',
                    content: 'playtech.mobile.system.geocomply.popups.geolocationNotAvailable.content',
                    isModal: true,
                    useTransparentPopup
                }));
            }

            throw error;
        }
    }, [dispatch, useTransparentPopup]);
};
